import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'
import moment from 'moment'

const getDefaultStateForVouchers = () => {
  return {
    gl_vouchers: [],
    vouchers:[],
    data:{},
    gl_voucher_filter:{
        keyword:"",
        active_only:"1",
        type:"GL"
    },
    voucher_filter:{
      keyword:"",
      active_only:"1",
      type:"VOUCHER"
    },
    is_created:null,
    is_updated:null,
    is_deleted:null,
    is_voided:null
  }
}
// state
const state = getDefaultStateForVouchers()
const getters = {
}
// mutations
const mutations = {
    SET_VOUCHER_VOIDED(state, data)
    {
      state.is_voided = data
    },
    SET_ACCOUNTS_FOR_FY(state, data)
    {
      state.accounts_for_fy = data
    },
    SET_FINANCIAL_YEARS(state, data)
    {
      state.fys = data
    },
    SET_ACCOUNT_TYPES(state, data)
    {
      state.account_types = data
    },
    FETCH_ALL(state, data){
        state.accounts = data
    },
    FETCH_ALL_VOUCHERS(state, data){
      if(data.data)
      {
        data.data.forEach(function(element) {
            element.voucher_date = (element.voucher_date != null && element.voucher_date != '') ? (moment(element.voucher_date).format('DD/MM/YYYY')) : '-'
            element.is_void_display = (element.is_void == 1) ?  'YES': 'NO'
        });

        if(data.type == 'GL')
            state.gl_vouchers = data.data
        else
            state.vouchers = data.data
      }
    },
    RESET_STATE_FOR_VOUCHERS (state) {
      Object.assign(state, getDefaultStateForVouchers())
    },
    FETCH_ACTIVE(state, data)
    {
        if(data)
        {
            state.active_accounts = data.data
        }
    },
    SET_IS_DELETED(state, data)
    {
      state.is_deleted = data
    },
    SET_IS_CREATED(state, data)
    {
      state.is_created = data
    },
    SET_VOUCHER_VOIDED(state, data)
    {
        state.is_voided = data
    },
    FETCH(state, data)
    {
      state.data = data
    }
}

// actions
const actions = {
    async void({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['VOID_VOUCHER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  commit('SET_VOUCHER_VOIDED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Voucher has been voided!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                commit('SET_VOUCHER_VOIDED', 0);

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
            }

          })
          .catch((error) => {
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  alert("Problem Creating Account")
              }
          });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_VOUCHER'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                  let doc_number  = response.data.data.code
                  commit('SET_IS_CREATED', 1);
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: 'Voucher (' + doc_number + ')' + " has been created!",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
            }
            else
            {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);
            }

          })
          .catch((error) => {
              if (error.response) 
              {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                alert("Problem Creating Voucher")
              }
          });
    },
    resetState({ commit, dispatch }, payload) {
      commit("RESET_STATE_FOR_VOUCHERS")
    },
    quickSearch({ commit }, data) {
      return axios.post(apiRoutes['QUICK_SEARCH_VOUCHERS'], data, authHeader())
          .then(response => {
            if(response.data.code == 1){
              commit('FETCH_ALL_VOUCHERS', {data:response.data.data, type:data.type})
            } else {
              commit('FETCH_ALL_VOUCHERS', {data:[], type:data.type})
            }
          })
          .catch(error => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    fetchVoucher({ commit }, data) {
      return axios.post(apiRoutes['RETRIEVE_VOUCHER'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
    },
    async voidVoucher({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['VOID_VOUCHER'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                    commit('SET_VOUCHER_VOIDED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: "Voucher has been voided!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
              }
              else
              {
                  let errors = response.data.data.errors
                  commit('SET_VOUCHER_VOIDED', 0);
  
                  if(Array.isArray(errors))
                  {
                    let msg = errors.join("\n")
  
                      Vue.notify({
                          group: 'notify',
                          type: 'error',
                          text: msg,
                          max: 5,
                          duration: 5000,
                          speed: 300
                      })
                  }
              }
  
            })
            .catch((error) => {
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    alert("Problem Creating Account")
                }
            });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
